// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./static/mobile_status_background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("static/web_status_background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acmg-report-status-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.status-background-image {
    width: 100%;
    position: absolute;
    background-size: cover;
    background: #FFFFFF url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    height: 224px;
    top: 0;
    background-size: cover;
}

.acmg-report-status-content {
    margin: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.statuses-list {
    margin-bottom: 20px;
}

.status-description {
    width: 285px;
    background: #06A9C9;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    text-align: center;
    font-size: 15px;
    color: #FFFFFF;
    box-sizing: border-box;
    padding: 10px;
    margin-top: 20px;
}

html[lang="ru"] .status-description {
    font-size: 14px;
    font-weight: 500;
}

.status-row {
    position: relative;
    height: 90px;
    display: flex;
    align-items: unset;
}

.rtl {
    padding-left: 30px;
    margin-right: 5px
}

.ltr {
    padding-right: 30px;
    margin-left: 5px
}

.status-icon {
    position: relative;
    right: 5px;
    padding-top: 33px;
    filter: drop-shadow(4px 4px 4px rgba(0, 0, 0, 0.17));
}

.index-colum {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.status-index {
    margin-top: 5px;
    position: absolute;
    top: 0;
    border-radius: 50%;
    padding: 5px;
    border: 0.5px solid #848484;
    width: 10px;
    line-height: 10px;
    text-align: center;
}

.status-index-checked {
    background: #F59544;
    border: none;
    color: #FFFFFF;
}


.status-vertical-line {
    margin-top: 35px;
    display: flex;
    justify-content: center;
    position: absolute;
    height: 60px;
    width: 1px;
    background: linear-gradient(#06A9C9, #FFFFFF);
}

.status-label {
    font-size: 18px;
    line-height: 24px;
    width: 150px;
    padding: 8px;
    margin-top: 5px;
}

html[lang="en"] .status-label {
    width: 220px;
}

html[lang="ru"] .status-label {
    font-size: 17px;
    width: 200px;
}

html[lang="ar"] .status-label {
    width: 200px;
}

.status-label-checked {
    background: #06A9C9;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    font-weight: 600;
    color: #FFFFFF;
}

.disclaimer-paragraph {
    margin-bottom: 1px;
    margin-right: 10px;
    width: 345px;
    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
    text-align: right;
    z-index: 1;

    color: #5F5F5F;
}

.thank-you-text {
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    color: #F59544;
    margin-top: 30px;
    margin-bottom: 20px;
    z-index: 1;
}


@media only screen and (min-width: 450px) {
    .status-background-image {
        background: #FFFFFF url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center top;
        height: 930px;
        background-size: cover;
    }

    .statuses-list {
        width: 550px;
        background: #FFFFFF;
        box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.21);
        border-radius: 25px;
        padding-top: 30px;
        z-index: 1;
        margin-top: -60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 30px;
    }

    .status-vertical-line {
        margin-top: 35px;
        height: 80px;
    }

    .status-row {
        height: 120px;
    }

    .status-index {
        height: 20px;
        width: 20px;
        font-size: 20px;
        line-height: 17px;
    }

    html[lang="en"] .status-index {
        line-height: 20px;
    }

    .status-label {
        font-weight: 400;
        font-size: 20px;
        line-height: 26px;
        width: 180px;
        margin-right: 10px;
    }

    html[lang="en"] .status-label {
        width: 220px;
    }

    html[lang="ru"] .status-label {
        font-size: 17px;
        width: 220px;
    }

    .status-icon {
        transform: scale(1.3);
        padding-top: 45px;
    }

    .status-description {
        width: 480px;
        font-size: 20px;
    }

    html[lang="ru"] .status-description {
        font-size: 17px;
    }

    .thank-you-text {
        font-size: 32px;
    }

    .disclaimer-paragraph {
        width: 400px;
    }

}`, "",{"version":3,"sources":["webpack://./src/AcmgReportStatus.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,4EAAiF;IACjF,aAAa;IACb,MAAM;IACN,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;;IAEV,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;AACd;;;AAGA;IACI;QACI,gFAAgF;QAChF,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,2CAA2C;QAC3C,mBAAmB;QACnB,iBAAiB;QACjB,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;AAEJ","sourcesContent":[".acmg-report-status-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.status-background-image {\n    width: 100%;\n    position: absolute;\n    background-size: cover;\n    background: #FFFFFF url(\"./static/mobile_status_background.png\") no-repeat center;\n    height: 224px;\n    top: 0;\n    background-size: cover;\n}\n\n.acmg-report-status-content {\n    margin: 30px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.statuses-list {\n    margin-bottom: 20px;\n}\n\n.status-description {\n    width: 285px;\n    background: #06A9C9;\n    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-weight: 600;\n    text-align: center;\n    font-size: 15px;\n    color: #FFFFFF;\n    box-sizing: border-box;\n    padding: 10px;\n    margin-top: 20px;\n}\n\nhtml[lang=\"ru\"] .status-description {\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.status-row {\n    position: relative;\n    height: 90px;\n    display: flex;\n    align-items: unset;\n}\n\n.rtl {\n    padding-left: 30px;\n    margin-right: 5px\n}\n\n.ltr {\n    padding-right: 30px;\n    margin-left: 5px\n}\n\n.status-icon {\n    position: relative;\n    right: 5px;\n    padding-top: 33px;\n    filter: drop-shadow(4px 4px 4px rgba(0, 0, 0, 0.17));\n}\n\n.index-colum {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.status-index {\n    margin-top: 5px;\n    position: absolute;\n    top: 0;\n    border-radius: 50%;\n    padding: 5px;\n    border: 0.5px solid #848484;\n    width: 10px;\n    line-height: 10px;\n    text-align: center;\n}\n\n.status-index-checked {\n    background: #F59544;\n    border: none;\n    color: #FFFFFF;\n}\n\n\n.status-vertical-line {\n    margin-top: 35px;\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    height: 60px;\n    width: 1px;\n    background: linear-gradient(#06A9C9, #FFFFFF);\n}\n\n.status-label {\n    font-size: 18px;\n    line-height: 24px;\n    width: 150px;\n    padding: 8px;\n    margin-top: 5px;\n}\n\nhtml[lang=\"en\"] .status-label {\n    width: 220px;\n}\n\nhtml[lang=\"ru\"] .status-label {\n    font-size: 17px;\n    width: 200px;\n}\n\nhtml[lang=\"ar\"] .status-label {\n    width: 200px;\n}\n\n.status-label-checked {\n    background: #06A9C9;\n    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    font-weight: 600;\n    color: #FFFFFF;\n}\n\n.disclaimer-paragraph {\n    margin-bottom: 1px;\n    margin-right: 10px;\n    width: 345px;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 17px;\n    text-align: right;\n    z-index: 1;\n\n    color: #5F5F5F;\n}\n\n.thank-you-text {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 26px;\n    text-align: center;\n    color: #F59544;\n    margin-top: 30px;\n    margin-bottom: 20px;\n    z-index: 1;\n}\n\n\n@media only screen and (min-width: 450px) {\n    .status-background-image {\n        background: #FFFFFF url(\"static/web_status_background.png\") no-repeat center top;\n        height: 930px;\n        background-size: cover;\n    }\n\n    .statuses-list {\n        width: 550px;\n        background: #FFFFFF;\n        box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.21);\n        border-radius: 25px;\n        padding-top: 30px;\n        z-index: 1;\n        margin-top: -60px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding-bottom: 30px;\n    }\n\n    .status-vertical-line {\n        margin-top: 35px;\n        height: 80px;\n    }\n\n    .status-row {\n        height: 120px;\n    }\n\n    .status-index {\n        height: 20px;\n        width: 20px;\n        font-size: 20px;\n        line-height: 17px;\n    }\n\n    html[lang=\"en\"] .status-index {\n        line-height: 20px;\n    }\n\n    .status-label {\n        font-weight: 400;\n        font-size: 20px;\n        line-height: 26px;\n        width: 180px;\n        margin-right: 10px;\n    }\n\n    html[lang=\"en\"] .status-label {\n        width: 220px;\n    }\n\n    html[lang=\"ru\"] .status-label {\n        font-size: 17px;\n        width: 220px;\n    }\n\n    .status-icon {\n        transform: scale(1.3);\n        padding-top: 45px;\n    }\n\n    .status-description {\n        width: 480px;\n        font-size: 20px;\n    }\n\n    html[lang=\"ru\"] .status-description {\n        font-size: 17px;\n    }\n\n    .thank-you-text {\n        font-size: 32px;\n    }\n\n    .disclaimer-paragraph {\n        width: 400px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
